<template>
  <div>
    <div>
      <v-banner class="subtitle" single-line >
        Teacher Performance - Individual
        <template v-slot:actions>
          <router-link slot="right" :to="{ name: 'teacherPerformance' }">
            <v-btn normal color="white" dark class="is-caption font-weight-bold">
                <v-icon>mdi-backburger</v-icon>
              back
            </v-btn>
          </router-link>
        </template>
      </v-banner>
    </div>
    <div class="py-5 px-4">
      <v-card>
        <v-row>
          <v-col cols="8" sm="6" md="8">
            <span class="py-1 px-3">Name:</span> {{trainingRecord.userName}}
          </v-col>
        </v-row>
        <!-- <v-row>
          <v-col cols="8" sm="6" md="8">
            <span class="py-1 px-3">Center Name:</span> {{trainingRecord.userName}}
          </v-col>
        </v-row> -->
      </v-card>
        <v-expansion-panels  v-model="panel" multiple class="py-3">
          <v-expansion-panel v-for="(record,i) in trainingRecord.trainings" :key="i" >
            <v-expansion-panel-header>
              Training Topic: {{record.name}}
              <v-divider
                class="mx-4"
                vertical
              ></v-divider>
              Center Name: {{record.franchiseeName}}
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-data-table
                :headers="headers"
                :items="record.trainingRecordModules"
                hide-default-footer
                class="elevation-1"
              >
                <template v-slot:item.moduleName="{item}">
                  {{item.name}}
                </template>
                <template v-slot:item.status="{item}">
                  {{item.attemptStatus || item.moduleStatus}}
                </template>

                <template v-slot:item.score="{ item }">
                  <span v-if="item.attemptStatus">
                    {{ item.score ? item.score : '0' }}/{{item.totalQuestions }}
                  </span>
                  <span v-else>
                    {{ item.score ? item.score : 'NA' }}{{ item.score ? ` /${item.totalQuestions}` : '' }}
                  </span>
                </template>
                <template v-slot:item.result="{item}">
                  {{item.result ? 'Passed' : 'NA'}}
                </template>
                <template v-slot:item.actions="{item}">
                  <v-btn
                    class="ma-2"
                    outlined
                    color="indigo"
                    @click="getAssessmentRecords(item.trainingAssessmentAttemptID, item.score)"
                  >
                   {{item.score ? 'View Assessment' : 'Not Available' }}
                  </v-btn>
                </template>
              </v-data-table>
              <v-row>
              <v-col offset-md="9">
                <v-btn v-if="record.status.toLowerCase() === 'completed'"
                  class="ma-2"
                  outlined
                  color="gray"
                  @click="showReportPDF(record)"
                >
                  Report Card
                </v-btn>
              </v-col>
            </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
    </div>
    <div v-if="isPdf">
      <teacher-report :printData="printableData"></teacher-report>
    </div>
    <div v-if="isAssessmentReport">
      <training-assessment-report :trainingAssessmentAttemptData="trainingAssessmentAttemptData"></training-assessment-report>
    </div>
    <loading-icon :value="isLoading" />
  </div>
</template>

<script>
import constants from '@/utils/constants'
// import _ from 'lodash'
// import moment from 'moment'
import { mapGetters } from 'vuex'
import TeacherReport from './teacherResult'
import TrainingAssessmentReport from './TeacherAssessmentReport'

export default {
  name: 'OnlineClassList',
  props: ['staffID'],
  components: {
    TeacherReport,
    TrainingAssessmentReport
  },
  data () {
    return {
      trainingRecord: [],
      totalModules: null,
      panel: [0],
      headers: [
        { text: 'Module Name', sortable: true, value: 'moduleName' },
        { text: 'Status', sortable: true, value: 'status' },
        { text: 'Score', sortable: true, value: 'score' },
        { text: 'Result', sortable: true, value: 'result' },
        { text: 'Action', value: 'actions', align: 'center', sortable: false }
      ],
      isLoading: false,
      printableData: {},
      isPdf: false,
      isAssessmentReport: false,
      trainingAssessmentAttemptData: {}
    }
  },

  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    })
  },
  mounted: async function () {
  },
  watch: {
    franchisee: async function (val) {
      await this.onFranchiseeChange()
    }
  },
  async created () {
    try {
      await this.getTeacherRecords()
    } catch (e) {
      const errorMessage = (e && e.response && e.response.data.message) || e.message
      this.errMsg(errorMessage)
    }
  },
  methods: {
    getAssessmentRecords: async function (id, score) {
      if (score) {
        try {
          this.isLoading = true
          let { data } = await http.get(`${constants.API_URL}/api/teacher-training/records/assessment/view/${id}`)
          this.isLoading = false
          this.isAssessmentReport = true
          this.trainingAssessmentAttemptData = data
          this.$nextTick(() => {
            this.printInvoice('printableAssessmentArea')
          })
        } catch (e) {
          this.isLoading = false
          const errorMessage = (e && e.response && e.response.data.message) || e.message
          this.errMsg(errorMessage)
        }
      }
    },
    showReportPDF (recordData) {
      this.isPdf = true
      this.printableData = recordData
      this.$nextTick(() => {
        this.printInvoice('printableArea')
      })
    },
    getTeacherRecords: async function () {
      try {
        this.isLoading = true
        let { data } = await http.get(`${constants.API_URL}/api/teacher-training/records/training-report/${this.staffID}`)
        this.isLoading = false
        this.trainingRecord = data
        for (const record of this.trainingRecord.trainings) {
          for (const item of record.trainingRecordModules) {
            if (item.moduleStatus === 'Failed' && item.score > 0) {
              item.moduleStatus = 'Completed'
              item.result = 'Passed'
            }
          }
        }
        // this.franchiseeData = data.rows
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    onFranchiseeChange: async function () {
      try {
        if (!this.inProgress) {
          this.inProgress = true
          if (this.franchisee) {
            this.franchiseeID = this.franchisee.id
          } else {
            this.franchiseeID = ''
          }
          if (this.academicYear) {
            this.academicYearID = this.academicYear.id
          } else {
            this.academicYearID = ''
          }
          this.inProgress = false
        }
      } finally {
        this.inProgress = false
      }
    },
    errMsg (msg) {
      return this.$buefy.dialog.alert({
        message: msg,
        type: 'is-danger',
        hasIcon: true,
        animation: 'zoom-out',
        size: 'is-medium',
        icon: ' mdi-exclamation',
        iconPack: 'mdi',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    },
    printInvoice: async function (content) {
      // Get HTML to print from element
      this.prtHtml = document.getElementById(content).innerHTML

      // Get all stylesheets HTML
      let stylesHtml = ''
      for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
        stylesHtml += node.outerHTML
      }

      // Open the print window
      const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=1300,toolbar=0,scrollbars=0,status=0')

      WinPrint.document.write(`<!DOCTYPE html>
<html>
  <head>
    ${stylesHtml}
  </head>
  <body>
    ${this.prtHtml}
  </body>
  <style>

  @media print {
    .page-break {
        height: 0;
        page-break-before: always;
        margin: 0;
        border-top: none;
    }
}

body, p{
    font-size: 9pt;
    font-family: Arial, Helvetica, sans-serif;
}

body {
    margin-left: 2em;
    margin-right: 2em;
    padding-left: 2em;
}

.card{
  padding-left: 2em;
}

.page {
    height: 1300px;
    padding-top: 5px;
    page-break-after: always;
    font-family: Arial, Helvetica, sans-serif;
    position: relative;
    border-bottom: 1px solid #000;
}
  </style>
</html>`)

      WinPrint.document.close()

      WinPrint.focus()

      setTimeout(function () {
        WinPrint.print()
      }, 500)
      // WinPrint.onfocus = function () {
      //   setTimeout(function () {
      //     // WinPrint.close()
      //   }, 800)
      // }

      this.resetAssessment()
      this.resetResult()
    },
    resetAssessment () {
      this.isAssessmentReport = false
      this.trainingAssessmentAttemptData = {}
    },
    resetResult () {
      this.printableData = {}
      this.isPdf = false
    }
  }
}
</script>
